import ApiService from './api-service'

class Organisation extends ApiService {
    constructor() {
        super()

        // this.get = null
        // this.post = null
        this.put = null
        // this.delete = null
    }

    list(options) {
      return super.get('/organisation', options)
    }

    clear(id) {
      if(id) return super.clear(`/organisation/${id}`)
      return super.clear('/organisation')
    }

    

    get(id, options) {
      return super.get(`organisation/${id}`, options)
    }

    create(payload, options) {
      return super.post(`organisation`, payload, options)
    }

    update(id, payload, options) {
      return super.put(`organisation/${id}`, payload, options)
    }

    delete(id, options) {
      return super.delete(`organisation/${id}`, options)
    }



    listGroups(id, options) {
      return super.get(`organisation/${id}/group`, options)
    }

    listChildren(id, groupId, options) {
      return super.get(`organisation/${id}/group/${groupId || `root`}/children`, options)
    }

    getGroup(id, groupId, options) {
      return super.get(`organisation/${id}/group/${groupId}`, options)
    }

    getGroupUser(id, groupId, userId, options) {
      return super.get(`organisation/${id}/group/${groupId}/user/${userId}`, options)
    }

    listGroupUsers(id, options) {
      options = options || {};
      return super.get(`organisation/${id}/group/user/v2`, options)
    }



    getStats(id, options) {
      return super.get(`organisation/${id}/stats`, options)
    }



    getUser(id, userId, options) {
      return super.get(`group/${id}/user/${userId}`, options)
    }

    getAssignments(id, options) {
      return super.get(`organisation/${id}/user/assignments`, options)
    }    

    assign(id, payload, options) {
      return super.post(`organisation/${id}/user/assign`, payload, options)
    }

    unassign(id, payload, options) {
      return super.post(`organisation/${id}/user/unassign`, payload, options)
    }

    invite(id, payload, options) {
      return super.post(`organisation/${id}/invite`, payload, options)
    }

    leave(id, options) {
      return super.post(`organisation/${id}/leave`, {}, options)
    }



    generateAccessCode(options) {
      return super.get(`accesscode`, options)
    }



    getContentFeed(id, options) {
      return super.get(`group/${id}/feed/content`, options)
    }

    getEventsFeed(id, options) {
      return super.get(`group/${id}/feed/events`, options)
    }



    listEmailTemplates(id, options) {
      return super.get(`organisation/${id}/template/email`, options)
    }

    listEmailTemplatesByType(id, type, options) {
      return super.get(`organisation/${id}/template/email/${type}`, options)
    }

    getEmailTemplate(id, type, templateId, options) {
      return super.get(`organisation/${id}/template/email/${type ? type : `any`}/${templateId}`, options)
    }

    createEmailTemplate(id, type, payload, options) {
      return super.post(`organisation/${id}/template/email/${type}`, payload, options)
    }

    updateEmailTemplate(id, type, templateId, payload, options) {
      return super.put(`organisation/${id}/template/email/${type}/${templateId}`, payload, options)
    }

    deleteEmailTemplate(id, type, templateId, options) {
      return super.delete(`organisation/${id}/template/email/${type}/${templateId}`, options)
    }



    listBatches(id, type, options) {
      return super.get(`organisation/${id}/batch/${type}`, options)
    }

    getBatch(id, type, batchId, options) {
      return super.get(`organisation/${id}/batch/${type}/${batchId}`, options)
    }

    createBatch(id, type, payload, options) {
      return super.post(`organisation/${id}/batch/${type}`, payload, options)
    }

    deleteBatch(id, type, batchId, options) {
      return super.delete(`organisation/${id}/batch/${type}/${batchId}`, options)
    }

    runBatch(id, type, batchId, options) {
      return super.post(`organisation/${id}/batch/${type}/${batchId}/run`, {}, options)
    }

    notifyBatch(id, type, batchId, payload = {}, options) {
      return super.post(`organisation/${id}/batch/${type}/${batchId}/notify`, payload, options)
    }

    listBatchTasks(id, type, batchId, options) {
      return super.get(`organisation/${id}/batch/${type}/${batchId}/tasks`, options)
    }

    deleteBatchTask(id, type, batchId, taskId, options) {
      return super.delete(`organisation/${id}/batch/${type}/${batchId}/task/${taskId}`, options)
    }
}

const _Organisation = new Organisation()
export default _Organisation
